<script lang="ts">
    export let size: string = "20px";


</script>
<div class="spinner" style="--size: {size}" />

<style>
    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .spinner {
        display: inline-block;
        box-sizing: border-box;
        width: calc(var(--size) - 4px);
        height: calc(var(--size) - 4px);
        border-radius: 50%;
        border: 2px solid #e2e8f0;
        border-top-color: #ccc;
        animation: spinner 1s linear infinite;
    }
</style>
